var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.$attrs['class'],attrs:{"color":"primary","dark":"","flat":"","max-width":_vm.$attrs['max-width']}},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{staticClass:"text-h4 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }